// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bbec7d01","143":"19f8e465","380":"6bea3482","835":"a37bc9a4","914":"b28e4c26"}[chunkId] + ".chunk.js";
};